<script lang="ts">
	import { getTranslate } from "@utils/getTranslate.js";
	import type { ClassValue } from "svelte/elements";
	import cockadeIcon from "@core/assets/icons/cockade.svg?raw";
	import translations from "./FFCMemberBadge.translations.json" with { type: "json" };
	import Formatted from "./Formatted.svelte";
	import Icon from "./Icon.svelte";

	const translate = getTranslate(translations);

	const { class: customClass }: { class: ClassValue } = $props();
</script>

<div
	class={[
		"items-center gap-2 rounded-full border border-fcrbrown",
		"px-3 py-1 text-sm/normal font-medium text-fcrbrown",
		customClass,
	]}
	aria-label={translate("ffcMemberBadge")}
>
	<Icon icon={cockadeIcon} class="size-4" />
	<Formatted text={translate("ffcMemberBadge")} />
</div>
